import React, { createContext, useContext, useState } from 'react';

const NftContext = createContext();

export const useNft = () => useContext(NftContext);

export const NftProvider = ({ children }) => {
  const [activeNft, setActiveNft] = useState({
    activeTokenAddress: null,
    level: null, 
    remainPotions: null, 
  });
  const [isLoading, setIsLoading] = useState(false); 

  const updateActiveNft = (nftData) => {
    setActiveNft(nftData);
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  return (
    <NftContext.Provider value={{ activeNft, updateActiveNft, isLoading, setLoading }}>
      {children}
    </NftContext.Provider>
  );
};
